const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M256,512c140.998,0,256-114.998,256-256S397.002,0,256,0S0,114.998,0,256 C0,396.998,114.998,512,256,512z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.376,
    y: 67.628,
    style: {
      fill: "#0F7986"
    },
    width: 325.834,
    height: 422.784
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DCE3DB"
    },
    points: "75.097,82.258 367.571,82.258 377.486,477.702 85.012,477.702 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.984,
    y: 82.259,
    style: {
      fill: "#FFFFFF"
    },
    width: 287.588,
    height: 385.727
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M188.548,57.351h78.764c5.672,0,10.314,4.642,10.314,10.314v33.856h-99.387V67.665 c0-5.672,4.642-10.314,10.314-10.314C188.553,57.351,188.548,57.351,188.548,57.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0"
    },
    d: "M176.109,98.962h103.646c2.194,0,3.972,1.778,3.972,3.97l0,0c0,2.193-1.779,3.97-3.972,3.97H176.109 c-2.194,0-3.972-1.778-3.972-3.97l0,0C172.137,100.739,173.915,98.962,176.109,98.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M217.572,47.074l-8.383,51.888h-4.314l8.36-51.753c-2.378-3.298-3.584-7.252-3.584-11.131 c0-2.485,0.494-4.956,1.496-7.215c1.011-2.282,2.54-4.347,4.591-6.004c6.526-5.266,17.838-5.27,24.364-0.005 c2.055,1.658,3.589,3.732,4.605,6.023c1.002,2.268,1.501,4.744,1.501,7.238c0,3.865-1.201,7.801-3.57,11.089l8.36,51.758h-4.314 l-8.383-51.888c-0.125-0.661,0.069-1.302,0.471-1.779c2.12-2.651,3.192-5.944,3.192-9.182c0-1.921-0.378-3.816-1.141-5.528 c-0.749-1.691-1.875-3.215-3.376-4.429c-4.96-4.004-14.101-3.995-19.057,0.005c-1.496,1.206-2.614,2.725-3.362,4.411 c-0.758,1.709-1.132,3.593-1.132,5.505c0,3.275,1.095,6.605,3.252,9.275c0.406,0.503,0.54,1.136,0.429,1.723l0,0L217.572,47.074 L217.572,47.074z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.281,
    y: 310.666,
    transform: "matrix(0.7485 0.6632 -0.6632 0.7485 343.4767 -160.7881)",
    style: {
      fill: "#21D0C3"
    },
    width: 24.836,
    height: 123.464
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M333.462,410.387l18.591,16.471l-22.05,13.196l-6.983-6.185L333.462,410.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M473.572,261.09l9.81,8.693c2.822,2.503,3.085,6.859,0.587,9.681l-49.07,55.384 c-0.13,0.148-0.351,0.157-0.494,0.028l-19.551-17.32c-0.143-0.13-0.157-0.351-0.028-0.494l49.07-55.384 c2.499-2.823,6.859-3.085,9.681-0.587h-0.005V261.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDB937"
    },
    d: "M483.969,279.468l-49.084,55.398c-0.13,0.13-0.328,0.143-0.471,0.028l-0.014-0.014l-2.364-2.097 l53.268-60.123c0.78,2.268,0.36,4.891-1.339,6.804L483.969,279.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M324.723,435.38l3.57,3.164l-7.565,8.54c-0.868,0.984-2.383,1.072-3.367,0.204l0,0 c-0.984-0.868-1.072-2.383-0.204-3.367L324.723,435.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M463.627,261.972l24.133,21.38l1.297,1.15l-1.215,1.371l-51.541,58.173l-0.471,0.531l-0.702,0.088 l-4.605,0.573c-1.967,0.005-2.522-3.159-0.25-3.547l3.898-0.485l49.855-56.27l-22.83-20.23l2.429-2.744v0.01H463.627z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 390.3,
    y: 317.868,
    transform: "matrix(0.7485 0.6632 -0.6632 0.7485 350.3004 -164.3752)",
    style: {
      fill: "#15BDB2"
    },
    width: 3.079,
    height: 123.464
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB2"
    },
    d: "M192.672,159.833c-1.348,0-2.443-1.095-2.443-2.443c0-1.348,1.095-2.443,2.443-2.443h40.312 l9.043-21.921c0.513-1.243,1.935-1.838,3.178-1.325c0.638,0.264,1.104,0.767,1.339,1.358l0.009-0.005l13.418,33.874l11.418-19.334 c0.684-1.16,2.18-1.543,3.339-0.859c0.365,0.218,0.656,0.517,0.859,0.859l6.623,10.152l9.598-10.207 c0.919-0.979,2.466-1.025,3.445-0.106c0.185,0.176,0.337,0.369,0.457,0.582l3.889,6.942h52.275c1.348,0,2.443,1.095,2.443,2.443 s-1.095,2.443-2.443,2.443h-53.702v-0.005c-0.854,0-1.682-0.448-2.125-1.247l-2.965-5.293l-9.441,10.041l-0.005-0.005 c-0.134,0.139-0.281,0.267-0.448,0.374c-1.127,0.73-2.637,0.411-3.367-0.716l-6.226-9.547l-11.889,20.134 c-0.263,0.508-0.702,0.924-1.271,1.15c-1.252,0.494-2.675-0.125-3.169-1.376l-13.035-32.9l-7.303,17.689 c-0.318,0.979-1.234,1.691-2.323,1.691L192.672,159.833L192.672,159.833z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 108.129,
    y: 222.036,
    style: {
      fill: "#C2C2C4"
    },
    width: 234.692,
    height: 3.967
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M134.064,95.506c-12.119,10.476-25.681,16.027-41.241,14.775 c-0.845,34.839,8.055,73.905,41.241,78.842c33.186-4.937,42.086-43.998,41.241-78.842 C159.745,111.534,146.184,105.982,134.064,95.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M97.132,130.004c0.065,27.56,6.762,64.501,36.932,69.466c30.17-4.965,36.867-41.911,36.932-69.466 c-13.722,0-25.957-5.011-36.932-13.699C123.086,124.993,110.85,130.004,97.132,130.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEFEFE"
    },
    d: "M127.478,133.635h13.172v17.666h17.667v13.172H140.65v17.667h-13.172v-17.667h-17.667v-13.172h17.667 C127.478,151.301,127.478,133.635,127.478,133.635z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.129,
    y: 241.987,
    style: {
      fill: "#C2C2C4"
    },
    width: 234.692,
    height: 3.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.129,
    y: 261.938,
    style: {
      fill: "#C2C2C4"
    },
    width: 234.692,
    height: 3.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.129,
    y: 281.889,
    style: {
      fill: "#C2C2C4"
    },
    width: 234.692,
    height: 3.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.129,
    y: 301.84,
    style: {
      fill: "#C2C2C4"
    },
    width: 234.692,
    height: 3.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.129,
    y: 321.792,
    style: {
      fill: "#C2C2C4"
    },
    width: 234.692,
    height: 3.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.129,
    y: 339.188,
    style: {
      fill: "#C2C2C4"
    },
    width: 103.408,
    height: 3.967
  })), /*#__PURE__*/React.createElement("rect", {
    x: 204.031,
    y: 442.316,
    style: {
      fill: "#21D0C3"
    },
    width: 103.408,
    height: 3.967
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M256,358.426c9.778,0,18.637,3.963,25.043,10.374c6.406,6.406,10.374,15.265,10.374,25.043 s-3.967,18.637-10.374,25.043S265.778,429.26,256,429.26s-18.637-3.967-25.043-10.374c-6.41-6.41-10.374-15.265-10.374-25.043 s3.963-18.637,10.374-25.043C237.367,362.389,246.222,358.426,256,358.426z M246.85,384.065c0-2.693,0.55-4.859,1.649-6.508 c1.099-1.649,2.749-2.721,4.946-3.21v-2.956h5.118v2.956c2.236,0.457,3.912,1.506,5.03,3.155c1.118,1.649,1.677,3.839,1.677,6.568 v1.252h-5.912v-1.649c0-1.441-0.272-2.452-0.822-3.039c-0.55-0.587-1.316-0.882-2.301-0.882s-1.751,0.295-2.3,0.882 c-0.55,0.587-0.826,1.603-0.826,3.039c0,1.367,0.304,2.54,0.91,3.524c0.605,0.984,1.362,1.903,2.273,2.758 c0.91,0.854,1.884,1.686,2.928,2.503s2.018,1.737,2.928,2.758c0.91,1.025,1.668,2.208,2.273,3.552s0.91,2.965,0.91,4.859 c0,2.73-0.568,4.928-1.705,6.595c-1.136,1.668-2.822,2.73-5.057,3.183v2.9h-5.118v-2.9c-2.273-0.457-3.972-1.515-5.09-3.183 c-1.118-1.668-1.677-3.865-1.677-6.595v-2.73h5.912v3.127c0,1.441,0.295,2.443,0.882,3.011s1.376,0.854,2.36,0.854 c0.984,0,1.774-0.286,2.36-0.854c0.587-0.568,0.882-1.575,0.882-3.011c0-1.362-0.3-2.54-0.91-3.524 c-0.605-0.984-1.367-1.903-2.273-2.758c-0.91-0.854-1.884-1.686-2.928-2.503s-2.018-1.737-2.928-2.758 c-0.91-1.025-1.668-2.208-2.273-3.552c-0.605-1.344-0.91-2.965-0.91-4.859L246.85,384.065z M278.378,371.464 c-5.727-5.727-13.639-9.27-22.378-9.27s-16.65,3.543-22.378,9.27c-5.728,5.727-9.27,13.639-9.27,22.378 c0,8.739,3.543,16.651,9.27,22.378c5.727,5.723,13.639,9.27,22.378,9.27c8.739,0,16.65-3.543,22.378-9.27 c5.723-5.727,9.27-13.639,9.27-22.378C287.648,385.104,284.105,377.192,278.378,371.464z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalHistory);
export default __webpack_public_path__ + "static/media/medical-history.3061521150b2599810b3b5bfc23b3f51.svg";
export { ForwardRef as ReactComponent };